import { writable } from 'svelte/store';
import { Api } from "./api";
import { Config } from "./config";
import { Cart } from "./cart/cart";
import { Toast } from "./toast";
import { Loader } from "./loader";
import { Client as SWClient } from "./solidwind";
import { User } from "./user";
export const config = writable(new Config());
export const api = writable(new Api());
export const cart = writable(new Cart());
export const modal = writable(null);
export const toast = writable(new Toast());
export const loader = writable(new Loader());
export const oidcToken = writable(undefined);
export const solidwindInstance = writable(undefined);
export const swClient = writable(new SWClient("", ""));
export const user = writable(new User());
export const isDisplayedBrandsPopup = writable(false);
